import React from "react";
import { Box, Flex, Text, CloseButton } from "@chakra-ui/react";
import { useNavigate } from "@reach/router";
import { basepath } from "../constants/basepath";

export const RouteItem = ({ title, children }) => {
  const navigate = useNavigate();
  return (
    <Box maxW="xs" bg="white" borderRadius="lg" p={2} boxShadow="lg">
      <Flex
        w="100%"
        alignItems="center"
        justifyContent="space-between"
        pb={2}
        mb={3}
        borderBottomWidth={1}
        borderBottomColor="gray.200"
      >
        <Text fontSize="lg">{title}</Text>
        <CloseButton onClick={() => navigate(`../../${basepath}`)} />
      </Flex>
      <Box>{children}</Box>
    </Box>
  );
};
